import './css/mobile.css';
import mobileIllustration from './img/Mobile.svg';
import gPlay from './img/Google_Play_Store_badge_EN.svg.webp';
import sync from './img/convert-arrow.svg';
import trade from './img/briefcase-line.svg';


export default function Mobile() {
  return (
    <div className="mobileApp">
      <h2>Try the <span className="logoNameII">i<span style={{color: 'rgb(59, 194, 149)'}}>Dey</span>Pay</span> mobile app</h2>
      <div className="mobile-items-container">
        <div className="mobile-left">
          <div className="mobile-left-item">
            <div className="mobile-left-item-img">
              <img src={sync} alt="[Buy and sell crypto]" />
            </div>
            <div className="mobile-left-item-desc">
              <h3>Buy and Sell</h3>
              <p>Easily buy and sell Bitcoin, Ethereum, Perfect Money and other cryptocurrencies.</p>
            </div>
          </div>
          <div className="mobile-left-item">
            <div className="mobile-left-item-img">
              <img src={trade} alt="trade" />
            </div>
            <div className="mobile-left-item-desc">
              <h3>Trade Anywhere</h3>
              <p>Access and keep track of your crypto portfolio from any internet-enabled mobile device</p>
            </div>
          </div>
        </div>
        <div className="mobile-right">
          <img src={mobileIllustration} alt="" />
        </div>
      </div>
      <div className="gplay">
        <a href="https://play.google.com/store/apps/details?id=com"><img src={gPlay} alt="[Google Play Logo]" /></a>
      </div>
    </div>
  )
}
